import { DateHelpers } from "../../helpers/date-helpers";
import { ObjectHelpers } from "../../helpers/object-helpers";

export class RealtimeTradeDataModel {
    public shouldCreateNewBar = false;
    //TODO: test this below. just see if it static or value change like a getter
    //public shouldUpdateExistingBar = !this.creatingNewBar;
    public high = 0;
    public low = 0;
    public open = 0;
    public close = 0;
    public symbol = '';
    public start: Date | null = null;
    public end: Date | null = null;
    public startTimeT = 0;
    public endTimeT = 0;
    public timestamp = 0;
    public xValue = 0;
    public isPreMarket = false;
    public isPostMarket = false;

    constructor(realtimeTradeData: any) {
        ObjectHelpers.setProperties(realtimeTradeData, this, true);

        if (this.start) {
            this.timestamp = DateHelpers.getTimeStampWithCurrentTimezone(this.start);
        }
    }

    public shouldUpdateExistingBar(): boolean {
        return !this.shouldCreateNewBar;
    }
}
